import React from 'react';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

const PostLogin = (props) => {

  // Init assets
  const initAssetConfig = {
    width: 200,
    height: 200,
    alt: 'defautl alt',
    description: 'default description',
    image: "/assets/images/default-images/popup_image.png",
    link: '',
    image_status: ''
  }
  // Set & get state
  const [assets, setAssets] = useState(initAssetConfig);
  const [isPopupEnabled, setIsPopupEnabled] = useState(true);

  // Fetch other media
  const { otherMedia } = useSelector(state => ({
    otherMedia: state.othermediaInformationListR.data
  }));



  // Effect call for manupulate data
  useEffect(() => {
    setAssets(initAssetConfig);
    // Width
    if (typeof otherMedia['pop_up_after_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_after_login']?.[0]['width'] != 'undefined') {
      assets['width'] = otherMedia['pop_up_after_login']?.[0]['width'];
      setAssets({
        ...assets
      })
    }

    // Heigth
    if (typeof otherMedia['pop_up_after_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_after_login']?.[0]['height'] != 'undefined') {
      assets['height'] = otherMedia['pop_up_after_login']?.[0]['height'];
      setAssets({
        ...assets
      })
    }

    // Description
    if (typeof otherMedia['pop_up_after_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_after_login']?.[0]['description'] != 'undefined') {
      assets['description'] = otherMedia['pop_up_after_login']?.[0]['description'];
      setAssets({
        ...assets
      })
    }

    // alternative
    if (typeof otherMedia['pop_up_after_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_after_login']?.[0]['alternate'] != 'undefined') {
      assets['alt'] = otherMedia['pop_up_after_login']?.[0]['alternate'];
      setAssets({
        ...assets
      })
    }

    // Image path
    if (typeof otherMedia['pop_up_after_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_after_login']?.[0]['path'] != 'undefined') {
      assets['image'] = otherMedia['pop_up_after_login']?.[0]['path'];
      setAssets({
        ...assets
      })
    }

    if (typeof otherMedia['pop_up_after_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_after_login']?.[0]['link'] != 'undefined') {
      assets['link'] = otherMedia['pop_up_after_login']?.['link'];
      setAssets({
        ...assets
      })
    }

    if (typeof otherMedia['pop_up_after_login']?.[0] != 'undefined' && typeof otherMedia['pop_up_after_login']?.[0]['image_status'] != 'undefined') {
      assets['image_status'] = otherMedia['pop_up_after_login']?.[0]['image_status'];
      setAssets({
        ...assets
      })
    }
  }, [otherMedia]);
  return (
    <>

      {
        assets['image_status'] && assets['link'] != '' &&
        <>
          <Link to={assets['link']} onClick={() => props.handle()}>
            <div className='popup-box1'>
              <div>
                <img
                  loading="lazy" src={assets['image']} width="400" height="auto" alt={assets['alt']} />
              </div>
            </div>
          </Link>
          {/* <label>
            <input
              type="checkbox"
              checked={!isPopupEnabled}
              onChange={() => { }}
              onClick={() => { props?.handlePopupCheckbox(isPopupEnabled); setIsPopupEnabled(!isPopupEnabled) }}
            />
            {props.t('dont_show_again')}
          </label> */}
          <div className='check'>
            <div className="d-flex prelogin-check align-items-center">
              <input
                type="checkbox"
                id="checkbor_arr"
                name="checkbor_arr"
                checked={!isPopupEnabled}
                onChange={() => { }}
                onClick={() => {
                  props?.handlePopupCheckbox(isPopupEnabled); setIsPopupEnabled(!isPopupEnabled)
                }}
              />
              <span></span>

              <label class="form-check-label" for="flexCheckChecked">
                {props.t('dont_show_again')}
              </label>
            </div>
          </div>
        </>
      }
    </>
  )
}

PostLogin.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
};

export default withTranslation()(PostLogin);
